<template>
  <b-button
    :class="[
      'btn-action-core justify-content-center align-items-center',
      variantClass,
    ]"
    size="sm"
    @click="handleClick"
    :style="customStyle"
    :disabled="isDisable"
    v-bind="{ 'v-b-modal': modalTarget }"
  >
    <div class="iconCore">
      <!-- Icon before text (ẨN TRÊN MOBILE) -->
      <i
        v-if="iconClass && isIconAfterText == false"
        :class="[iconClass, 'icon-btn-core me-2 icon-mobile-hide']"
      ></i>
      {{ text }}
      <!-- Icon after text (ẨN TRÊN MOBILE) -->
      <i
        v-if="iconClass && isIconAfterText"
        :class="[iconClass, 'ms-2 icon-mobile-hide']"
      ></i>
    </div>
  </b-button>
</template>

<script>
export default {
  name: "ButtonCore",
  props: {
    // Label hiển thị trên nút
    text: {
      type: String,
      required: true,
    },
    // Hàm xử lý khi nút được click.
    // Nếu có modalTarget, hàm này sẽ được gọi TRƯỚC khi modal mở.
    handleClick: {
      type: Function,
      default: () => {},
    },
    // ID của modal cần mở (Ví dụ: 'modal-close_visit').
    modalTarget: {
      type: String,
      default: null,
    },
    // Trạng thái tắt/bị vô hiệu hóa của nút
    isDisable: {
      type: Boolean,
      default: false,
    },
    isIconAfterText: {
      type: Boolean,
      default: false,
    },
    // Class CSS đặc thù cho màu sắc/biến thể
    variantClass: {
      type: String,
      default: "btn-default-core",
    },
    // Class icon (ví dụ: 'fas fa-trash-alt')
    iconClass: {
      type: String,
      default: "",
    },
    // Style tùy chỉnh nếu cần (ví dụ: height, width)
    customStyle: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style scoped>
/* Style cơ bản áp dụng cho tất cả các nút Core */
.btn-action-core {
  /* Thiết lập kích thước */
  height: 40px;
  font-size: 1rem;

  /* Định dạng chung */
  border: none !important;
  font-weight: bold;
  border-radius: 6px;
  padding: 6px 10px;

  /* Thiết lập hiển thị */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Hiệu ứng chuyển động */
  /* transition: background-color 0.2s, box-shadow 0.2s, transform 0.2s,
    border-color 0.2s, color 0.2s; */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-action-core:not([disabled]):hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  /* transform: translateY(-1px); */
}

/* ======================================= */
/* 1. BIẾN THỂ CÓ NỀN (FILLED VARIANTS) */
/* ======================================= */

/* Accept/Chấp nhận (Success Green) */
.btn-accept-core,
.btn-success-core {
  background-color: var(--color-secondary);
  color: #ffffff;
}
.btn-accept-core:not([disabled]):hover,
.btn-success-core:not([disabled]):hover {
  background-color: var(--color-secondary-dark);
}

/* Delete/Xóa (Danger Red) */
.btn-delete-core,
.btn-danger-core {
  background-color: var(--color-danger);
  color: #ffffff;
}
.btn-delete-core:not([disabled]):hover,
.btn-danger-core:not([disabled]):hover {
  background-color: var(--color-danger-dark);
}

/* Edit/Sửa (Warning Yellow) */
.btn-edit-core {
  background-color: var(--color-accent-yellow-base);
}
.btn-edit-core:not([disabled]):hover {
  background-color: var(--color-accent-yellow-dark);
  color: #ffffff !important;
}

/* Search/Tìm kiếm (Primary/Info Blue hoặc Custom Yellow) */
.btn-search-core {
  background-color: var(--color-blue-sky); /* Info Blue */
  color: #ffffff;
}
.btn-search-core:not([disabled]):hover {
  background-color: var(--color-blue-sky-dark);
}

/* ======================================= */
/* 2. BIẾN THỂ CHỈ VIỀN (OUTLINE VARIANTS) */
/* ======================================= */
/* Close/Đóng (Outline Xám) */
.btn-deleteOutline-core,
.btn-deleteOutline-core {
  border: 1px solid var(--color-danger) !important; /* Viền xám 1px */
  background-color: transparent !important;
  color: var(--color-danger) !important; /* <--- ĐÃ THÊM !important */
}

.btn-deleteOutline-core:not([disabled]):hover,
.btn-deleteOutline-core:not([disabled]):hover {
  /* background-color: var(--color-dark) !important; */
  color: var(--color-danger) !important;
  border: 1.5px solid var(--color-danger) !important;
}

/* Close/Đóng (Outline Xám) */
.btn-close-core,
.btn-outline-core {
  border: 1px solid var(--color-gray) !important; /* Viền xám 1px */
  background-color: transparent !important;
  color: var(--color-dark) rgba(0, 0, 0, 0.1) !important; /* <--- ĐÃ THÊM !important */
  box-shadow: none;
}

.btn-close-core:not([disabled]):hover,
.btn-outline-core:not([disabled]):hover {
  /* background-color: var(--color-dark) !important; */
  color: var(--color-dark) !important;
  border: 1px solid var(--color-dark) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* Outline Info (Đã chỉnh viền 1px) */
.btn-outline-info-core {
  border: 1px solid var(--color-blue-sky) !important; /* Màu xanh Info 1px */
  background-color: transparent !important;
  color: var(--color-blue-sky) !important; /* <--- ĐÃ THÊM !important */
  box-shadow: none;
}

.btn-outline-info-core:not([disabled]):hover {
  background-color: var(--color-blue-sky) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

/* ======================================= */
/* 3. TRẠNG THÁI VÔ HIỆU HÓA (DISABLED STATE) */
/* ======================================= */
.btn-action-core[disabled] {
  opacity: 0.65;
  cursor: not-allowed;
  /* Loại bỏ tất cả hiệu ứng hover/transform */
  box-shadow: none !important;
  transform: none !important;
}

/* ======================================= */
/* 4. RESPONSIVE FIX: ẨN ICONS TRÊN MOBILE */
/* ======================================= */

@media (max-width: 767.98px) {
  /* Ẩn icon trên các thiết bị nhỏ hơn tablet */
  .icon-mobile-hide {
    display: none !important;
  }

  /* Xóa margin của icon nếu nó bị ẩn */
  .btn-action-core .iconCore .me-2,
  .btn-action-core .iconCore .ms-2 {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .btn-action-core {
    /* Thiết lập kích thước */
    height: 32px;
    font-size: 0.95rem;
    border-radius: 6px;
    padding: 5px 8px;
  }
}
</style>
